// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YZbXA","content":"styles_content__3sGhE"};